export default "__VITE_ASSET__ClllbAt0__"